const parseBoolean = (str = '') => str.toLowerCase() === 'true';

// Feature flags
export const MULTI_FACTOR_AUTHENTICATION = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_MULTI_FACTOR_AUTHENTICATION
);
export const RESIDEO_ACADEMY_SPLASH_PAGE = parseBoolean(
  import.meta.env.REACT_APP_RESIDEO_ACADEMY_NEW_SPLASHPAGE
);

export const REQUEST_MY_DATA = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_REQUEST_MY_DATA
);

export const FIRST_ALERT_CONNECTED_ACCOUNTS = parseBoolean(
  import.meta.env.REACT_APP_FIRST_ALERT_CONNECTED_ACCOUNTS
);

export const ADD_DISTRIBUTOR_OPTION_USER_TYPE = parseBoolean(
  import.meta.env.REACT_APP_ADD_DISTRIBUTOR_OPTION_USER_TYPE
);

export const DATA_ERASURE = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_DATA_ERASURE
);

export const CENTRAL_STATION_BUSINESS_TYPE = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_CENTRAL_STATION_BUSINESS_TYPE
);

export const SIGNUP_RECAPTCHA = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_SIGNUP_RECAPTCHA
);

export const SFTY_WORKFLOW = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_SFTY_WORKFLOW
);

export const RESIDEO_TECH_APP = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_RESIDEO_TECH_APP
);

export const RESIDEO_CONNECT_LOGO = parseBoolean(
  import.meta.env.REACT_APP_FEATURE_RESIDEO_CONNECT_LOGO
);

export const MAINTENANCE_MODE = parseBoolean(
  import.meta.env.REACT_APP_SITE_OUTAGE_KILLSWITCH
);
